<script lang="ts" setup>
const props = defineProps<{ helper?: string }>()
</script>

<template>
    <span v-if="props.helper" class="block pl-2 text-xs text-primary-400" v-text="props.helper" />
</template>
